// extracted by mini-css-extract-plugin
module.exports = {"copyInstallBtn":"Intro_copyInstallBtn__2fqOK","terminalCode":"Intro_terminalCode__1RwzD","clickToCopyText":"Intro_clickToCopyText__WGaOY","codeToCopy":"Intro_codeToCopy__1bHa7"};